import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import root from 'window-or-global';

class ScrollToTop extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        children: PropTypes.object
    };

    componentDidUpdate(prevProps) {
        const currentLocation = this.props.location || {};

        if (currentLocation !== prevProps.location) {
            //ROUTE CHANGE HAS OCCURRED
            root.scrollTo(0, 0);
        }
    }

    render() {
        return React.cloneElement(this.props.children, {cmsPage: root.cmsPage});
    }
}

export default withRouter(ScrollToTop);
